// if (!document.documentElement.classList.contains('shopify-design-mode')) {
//   coMM.add("(min-width: 750px)", () => {
//     ScrollTrigger.create({
//       // markers: true,
//       trigger: ".co-main-collection-product-grid-wrapper",
//       start: "top top",
//       end: "bottom bottom",
//       pinSpacing: false,
//       pin: ".co-collection-grid-menu"
//     });
//   })
// }
let coCollectionTimeline = gsap.timeline();
gsap.set(".co-main-collection-product-grid-wrapper", { opacity: 0 });
gsap.set(".product-grid-container .grid__item", { opacity: 0 });
coCollectionTimeline.to('.co-main-collection-product-grid-wrapper', {
  duration: 0.5,
  ease: "power1.inOut",
  opacity: 1
});
coCollectionTimeline.to('.co-header-spacer', {
  duration: 0.5,
  ease: "power1.inOut",
  opacity: 1
}, "-=0.5");
coCollectionTimeline.to(".product-grid-container .grid__item", {
  opacity: 1,
  duration: 0.5,
  ease: "power1.inOut",
  stagger: 0.05
}, "-=0.4");

gsap.set(".co-collection-hero-module-top-image-frame", { height: "110%" });
gsap.to('.co-collection-hero-module-top-image-frame', {
  scrollTrigger: {
    trigger: "body",
    endTrigger: ".co-collection-hero-module-top-content",
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  top: "-10%"
});